const toSlug = (value = "") =>
  value
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export function getVendorIdentifier(vendor) {
  if (!vendor || typeof vendor !== "object") {
    return "";
  }

  if (vendor.containerPath) {
    return vendor.containerPath;
  }
  if (vendor.slug) {
    return vendor.slug;
  }

  const slugSource =
    vendor.codice ||
    vendor.denominazioneSociale ||
    vendor.denominazione ||
    vendor.name ||
    vendor.nome ||
    "";

  const slug = toSlug(slugSource);
  if (slug) {
    return slug;
  }

  return vendor.id || vendor._id || "";
}

export function getVendorRoute(vendor) {
  const identifier = getVendorIdentifier(vendor);
  if (!identifier) {
    return { name: "Vendors" };
  }
  return {
    name: "VendorDetail",
    params: { vendorId: identifier },
  };
}
